module.exports = __webpack_public_path__ + "7d0c4708dd6a3d32b59ef458c37fe144.png";